import { inject, InjectionKey } from "vue";
import { registerStore } from "../../core/store";
import { State } from "../../core/store/types";
import { themeSelectorStoreFeatures } from "./features";
import { ThemeSelectorNonPageableData, ThemeSelectorSetup, ThemeSelectorStoreFeatures, ThemeSelectorStoreState } from "./types";

export const themeSelectorStoreKey: InjectionKey<ThemeSelectorStoreState> = Symbol("themeSelectorStore");
export const themeSelectorStore = registerStore<ThemeSelectorStoreFeatures, ReturnType<typeof setupStore>, ReturnType<typeof setupState>, ThemeSelectorNonPageableData>(themeSelectorStoreKey, themeSelectorStoreFeatures, setupStore, setupState);

function setupStore()
{
    return {
        defaultThemeSelectorId: "ThemeSelector",
        get defaultThemeSelectorPromise(): Promise<ThemeSelectorSetup>
        {
            return themeSelectorStore.getStateAsync(this.defaultThemeSelectorId)
        },
        injectThemeSelectorState,
    };

    function injectThemeSelectorState(): ThemeSelectorStoreState
    {
        return inject(themeSelectorStoreKey, undefined) as ThemeSelectorStoreState;
    }
}

function setupState(themeSelectorID: string, storeState: State<ThemeSelectorStoreFeatures, {}, {}, {}, ThemeSelectorNonPageableData>): ThemeSelectorSetup
{
    const state =
    {
        get themeSelectorID() { return themeSelectorID; },
    };

    return state;
}
